import Marquee from "react-fast-marquee";

const ITEMS = ["Own Nothing. Control Everything.", "U.S. Veteran Owned and Operated", "One Portal. Complete Protection.", "Military Legal Review Included"];

export const GoldMarquee = () => (
  <div className="border-y border-gold/15 bg-inkdeep py-6 sm:py-8" data-testid="editorial-marquee">
    <Marquee speed={38} gradient={false} autoFill>
      {ITEMS.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display italic text-2xl sm:text-3xl text-cream/25 px-8 whitespace-nowrap">{t}</span>
          <span className="text-gold text-lg" aria-hidden="true">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
